import { P2GBox, useTheme, P2GGrid, P2GTooltip } from '@parcel2go/core-ui';
import { Fragment, useMemo } from 'react';
import { TrackingSummaryApiModel } from '~/lib/api/smartsend/types';
import CalculateLatestTrackingStep from './CalculateLatestTrackingStep';

interface props {
  tracking: TrackingSummaryApiModel;
}

const TrackingSpacer = () => <div style={{ height: '10px', width: '3px' }}></div>;

const TrackingStage = (props: { latestStageNumber: number; stage: number }) => {
  const theme = useTheme();
  return (
    <P2GBox backgroundColour={props.latestStageNumber >= props.stage ? theme.palette.success.main : '#f1f1f1'}>
      <TrackingSpacer />
    </P2GBox>
  );
};

export default function TrackingProgress(props: props) {
  const latestStageNumber = useMemo<number>(() => CalculateLatestTrackingStep(props.tracking), [props.tracking]);
  const steps = [1, 2, 3, 4, 5];
  return (
    <P2GTooltip
      title={props.tracking?.LatestStatus || 'Tracking Status'}
      children={
        <div style={{ overflow: 'hidden', borderRadius: '5px' }}>
          <P2GGrid container justify="space-evenly" alignItems="center" alignContent="center">
            {steps.map((stage) => (
              <Fragment key={`${stage}`}>
                {stage > 1 && (
                  <P2GGrid item flexShrink={1}>
                    <TrackingSpacer />
                  </P2GGrid>
                )}
                <P2GGrid item flexGrow={1}>
                  <TrackingStage latestStageNumber={latestStageNumber} stage={stage} />
                </P2GGrid>
              </Fragment>
            ))}
          </P2GGrid>
        </div>
      }
    />
  );
}
